import React, { Component } from 'react';
import PubSub from 'pubsub-js'
import { meshLog } from "../../../utils/spUtils";
import './attentionDialog.less';
import close_btn from '../../../imgs/btn/close_btn.png';
import warning from "../../../imgs/item/warning.png";
import { Attention_Area, Attention_Build, Attention_DIALOG_HIDE, Attention_DIALOG_SHOW, Attention_Scene, Attention_Share } from '../../../const/infoConst';


let mType="";
export default class attentionDialog extends Component {
    constructor(a) {
        super(a);
        this.state = {
            control: 'Dim Level',
            mInfo:"",
        }
    }

    componentDidMount() {
        PubSub.subscribe(Attention_DIALOG_SHOW, (msg, data) => { //警示弹框
            mType=data;
            this.updateAttenUI();
            meshLog("警示弹窗",data);
        })
    }

    updateAttenUI(){
        let mm="";
        if(mType==Attention_Scene){
            mm="Do you want to delete this scene? All associated data will be cleared together and cannot be recovered after deletion.";
        }else if(mType==Attention_Build){
            mm="Please confirm whether you want to delete this building. This operation is irreversible, and all associated data will be permanently erased.";
        }else if(mType==Attention_Area){
            mm="Please confirm whether you want to delete this Area. This operation is irreversible, and all associated data will be permanently erased.";
        }else if(mType==Attention_Share){
            mm="Are you sure you want to remove this user's administrative privileges?";
        }
        this.setState({
            mInfo:mm,
        })
    }


    closeBtnClick = async () => {
        meshLog("closeBtnClick");
        PubSub.publish(Attention_DIALOG_HIDE,"")
    }

    delBtnClick = async () => {
        meshLog("delBtnClick");
        PubSub.publish(Attention_DIALOG_HIDE,mType)
    }


    render() {
        const { mInfo } = this.state;
        return (
            <div className="atten_container">
                <div className="ui_grey_bg" />
                <div className="atten_dialog" style={{left:(document.body.clientWidth-600)/2}}>
                     {/* 关闭按钮 */}
                    <img className='closeBtn' src={close_btn} onClick={() => { this.closeBtnClick() }}/>
                    {/* 标题 */}
                    <div className="atten_title">
                        <img className='icon' src={warning}/>
                        <span>Attention</span>
                    </div>
                    {/* 控制 */}
                    <div className='atten_info'>
                        <span>{mInfo}</span>
                    </div>
                    

                    {/* 底部按钮 */}
                    <div className="atten-footer">
                        <button className='cancelBtn' onClick={() => { this.closeBtnClick() }}>Cancel</button>
                        <button className='okBtn' onClick={() => { this.delBtnClick() }}>Confirm</button>
                    </div>
           
               
                </div>
            </div>
        );

    }
};